import s from '../styles/pages/guide.module.scss'
import {useMemo, useState} from "react";
import Popup from "../elements/popup";
import {ReactComponent as SettingsLogo} from '../assets/settings-logo.svg';
import {ReactComponent as JobLogo} from "../assets/job.svg";
import {ReactComponent as WindowLogo} from "../assets/window.svg";
import {ReactComponent as HeadhunterIcon} from "../assets/hh.svg";
import {ReactComponent as SubscriptionIcon} from '../assets/subscription.svg';
import {ReactComponent as ReloadIcon} from "../assets/reload.svg";
import { Bitrix24Form } from 'react-bitrix24-form';
import React from "react";

// Компонент главной страницы руководств
function GettingStartedTab({BX24}) {
    const [activeGuide, setActiveGuide] = useState(null);

    const guides = useMemo(() => [
        {
            id: 'initial-setup',
            title: "Первичная настройка",
            icon: <SettingsLogo/>,
            description: "Настройка смарт-процессов и сопоставление полей",
            component: InitialSetupGuide
        },
        {
            id: 'extension',
            title: "Работа с расширением",
            icon: <WindowLogo/>,
            description: "Установка и использование браузерного расширения",
            component: ExtensionGuide
        },
        {
            id: 'analysis',
            title: "Анализ соискателя",
            icon: <SubscriptionIcon/>,
            description: "Использование AI-анализа кандидатов",
            component: AnalysisGuide
        },
        {
            id: 'hh-automation',
            title: "Автоматизация HH.ru",
            icon: <HeadhunterIcon/>,
            description: "Настройка автозанесения откликов",
            component: HHAutomationGuide
        },
        {
            id: 'chat',
            title: "Чат с соискателями",
            icon: <JobLogo/>,
            description: "Общение с кандидатами прямо из CRM",
            component: ChatGuide
        },
        {
            id: 'refresh',
            title: "Обновление данных",
            icon: <ReloadIcon/>,
            description: "Актуализация информации в карточках соискателей",
            component: RefreshGuide
        }
    ], [])

    const openGuide = (guideId) => {
        setActiveGuide(guideId);
    };

    const closeGuide = () => {
        setActiveGuide(null);
    };

    const renderGuide = () => {
        if (!activeGuide) return null;

        const guide = guides.find(g => g.id === activeGuide);
        if (!guide) return null;

        const GuideComponent = guide.component;
        return (
            <Popup openedFlag={true} setOpenedFlag={closeGuide}>
                <GuideComponent onClose={closeGuide}/>
            </Popup>
        );
    };


    const [formOpened, setFormOpened] = useState(false)
    const openForm = () => {
        setFormOpened(true)
    }
    const closeForm = () => {
        setFormOpened(false)
    }

    const renderForm = () => {
        if (!formOpened) return null;
        return (
            <Popup openedFlag={true} setOpenedFlag={closeForm}>
                <Bitrix24Form
                    src='https://wfcrm.ru/upload/crm/form/loader_48_ywc022.js'
                    data="inline/48/ywc022"
                />
            </Popup>
        );
    }

    return (
        <div className={s.gettingStartedTab}>
            <div className={s.guideHeader}>
                <h2>Руководства по использованию ResumeScan</h2>
                <p>Выберите интересующий вас модуль для просмотра пошаговой инструкции</p>
            </div>

            <div className={s.guidesGrid}>
                {guides.map(guide => (
                    <div
                        key={guide.id}
                        className={s.guideCard}
                        onClick={() => openGuide(guide.id)}
                    >
                        <div className={s.guideIcon}>{guide.icon}</div>
                        <h3>{guide.title}</h3>
                        <p>{guide.description}</p>
                        <div className={s.guideAction}>Открыть руководство</div>
                    </div>
                ))}
            </div>

            {/* Новый блок с призывом к действию */}
            <div className={s.demoSection}>
                <h3>Запишитесь на демо-сессию с экспертом</h3>
                <p>
                    Получите персональную помощь эксперта: вместе настроим ResumeScan в вашем Битрикс24 и ответим на все вопросы.
                    Если вы думаете, что в настройках приложения может быть много деталей — не переживайте, вы не останетесь один на один с терминами и галочками.
                </p>
                <p>
                    Договоримся о времени, созвонимся в удобном для вас чате или мессенджере и за 45 минут вместе с экспертом пройдём все шаги в тестовом Битрикс24.
                    Вы увидите, как приложение работает и сможете задать любые вопросы в процессе.
                </p>

                <div className={s.demoBenefits}>
                    <h4>Что будет на встрече</h4>
                    <ul>
                        <li>Откроем тестовый портал Bitrix24 и настроим ключевые пункты вместе</li>
                        <li>Покажем работу всех функций приложения на реальных примерах</li>
                        <li>Ответим на любые технические и бизнес-вопросы</li>
                        <li>Дадим советы по дальнейшему внедрению</li>
                    </ul>
                </div>

                <p className={s.demoNote}>Заполнение формы займёт не больше минуты.</p>

                <button
                    className={s.demoButton}
                    onClick={openForm}
                >
                    Записаться на демо
                </button>
            </div>
            {renderForm()}
            {renderGuide()}
        </div>
    );
}

export default React.memo(GettingStartedTab);

// Компоненты руководств для каждого модуля
function InitialSetupGuide({onClose}) {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            title: "Настройка смарт-процесса для сохранения резюме",
            content: (
                <div className={s.guideStep}>
                    <p>ResumeScan позволяет сохранять данные кандидатов в различные смарт-процессы: лиды, сделки или
                        кастомные смарт-процессы.</p>

                    <div className={s.instruction}>
                        <h4>Как выбрать смарт-процесс:</h4>
                        <ol>
                            <li>Перейдите в раздел <strong>"Настройка соискателей"</strong></li>
                            <li>В поле "Выберите, куда сохранять резюме" выберите нужный смарт-процесс</li>
                            <li>Если смарт-процесс не отображается, попробуйте перезагрузить страницу</li>
                            <li>Нажмите "Сохранить" для применения изменений</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Рекомендация:</strong> Для работы с кандидатами лучше создать отдельный смарт-процесс
                        "Кандидаты" или "Резюме", чтобы не смешивать их с другими бизнес-процессами.
                    </div>
                </div>
            )
        },
        {
            title: "Настройка сопоставления полей данных",
            content: (
                <div className={s.guideStep}>
                    <p>Чтобы данные из резюме правильно сохранялись в CRM, необходимо сопоставить поля.</p>

                    <div className={s.instruction}>
                        <h4>Как настроить поля:</h4>
                        <ol>
                            <li>В разделе "Настройка соискателей" нажмите кнопку "Настроить сохраняемые данные"</li>
                            <li>Для каждого элемента данных выберите соответствующее поле в вашем смарт-процессе</li>
                            <li>Если нужного поля нет - создайте его в настройках смарт-процесса</li>
                            <li>Обязательно настройте поля для контактов: телефон и email</li>
                            <li>По завершении нажмите "Сохранить"</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Важно:</strong> Поле "Вакансия" нужно для привязки кандидата к конкретной вакансии в
                        CRM.
                        Если вы планируете использовать эту функцию, обязательно настройте это поле.
                    </div>
                </div>
            )
        },
        {
            title: "Проверка корректности настроек",
            content: (
                <div className={s.guideStep}>
                    <p>После настройки рекомендуется проверить, что все работает корректно.</p>

                    <div className={s.instruction}>
                        <h4>Как проверить настройки:</h4>
                        <ol>
                            <li>Сохраните любое резюме через расширение</li>
                            <li>Проверьте, что в карточке элемента заполнены все необходимые поля</li>
                            <li>Убедитесь, что контактные данные сохранены корректно</li>
                            <li>Если есть ошибки - проверьте сопоставление полей</li>
                        </ol>
                    </div>
                </div>
            )
        }
    ];

    return <GuideTemplate title="Первичная настройка" steps={steps} onClose={onClose}/>;
}

function ExtensionGuide({ onClose }) {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            title: "Получение лицензионного ключа для расширения",
            content: (
                <div className={s.guideStep}>
                    <p>Перед использованием расширения необходимо получить лицензионный ключ в приложении.</p>

                    <div className={s.instruction}>
                        <h4>Как получить ключ:</h4>
                        <ol>
                            <li>Перейдите в раздел <strong>"Работа с расширением"</strong> в основном приложении</li>
                            <li>Найдите блок "Список лицензионных ключей расширения"</li>
                            <li>Введите название для нового ключа (например, имя сотрудника)</li>
                            <li>При необходимости выберите ответственного за ключ</li>
                            <li>Нажмите кнопку "+" для создания ключа</li>
                            <li>Скопируйте созданный лицензионный ключ - он понадобится для авторизации</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Важно:</strong> Каждый сотрудник должен иметь свой лицензионный ключ.
                        Это позволяет отслеживать, кто именно сохраняет резюме, и назначать ответственных.
                    </div>
                </div>
            )
        },
        {
            title: "Установка расширения и авторизация",
            content: (
                <div className={s.guideStep}>
                    <p>После получения лицензионного ключа можно установить и настроить расширение.</p>

                    <div className={s.instruction}>
                        <h4>Процесс установки и авторизации:</h4>
                        <ol>
                            <li>Перейдите в раздел <strong>"Работа с расширением"</strong></li>
                            <li>Нажмите кнопку "Скачать расширение"</li>
                            <li>Установите расширение в браузер (Chrome, Edge или Yandex Browser)</li>
                            <li>При первом запуске расширения введите ваш лицензионный ключ</li>
                            <li>Нажмите "Авторизоваться" для подключения к вашему порталу</li>
                            <li>После успешной авторизации расширение готово к работе</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Информация:</strong> Лицензионный ключ нужно вводить только один раз при первом
                        использовании расширения. В дальнейшем расширение будет автоматически подключаться к вашему порталу.
                    </div>
                </div>
            )
        },
        {
            title: "Как использовать расширение",
            content: (
                <div className={s.guideStep}>
                    <p>После установки и авторизации расширение готово к работе.</p>

                    <div className={s.instruction}>
                        <h4>Процесс работы:</h4>
                        <ol>
                            <li>Перейдите на страницу кандидата на HH.ru</li>
                            <li>Нажмите на иконку расширения в браузере</li>
                            <li>Выберите направление (воронку) для сохранения</li>
                            <li>Чтобы прикрепить резюме к вакансии, начните вводить её название — появится список для выбора</li>
                            <li>При необходимости выберите ответственного: из токена, из вакансии или начните вводить имя сотрудника</li>
                            <li>Нажмите "Сохранить резюме"</li>
                            <li>Через несколько секунд резюме будет сохранено в CRM и вы получите ссылку на элемент</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Особенности:</strong> Расширение автоматически проверяет дубликаты по
                        email и телефону. Если кандидат уже есть в CRM, вы получите уведомление.
                    </div>
                </div>
            )
        },
        {
            title: "Решение распространенных проблем",
            content: (
                <div className={s.guideStep}>
                    <p>Вот решения для наиболее частых проблем, возникающих при работе с расширением.</p>

                    <div className={s.instruction}>
                        <h4>Проблемы и решения:</h4>
                        <ul>
                            <li><strong>Расширение не авторизуется</strong> - проверьте правильность лицензионного ключа</li>
                            <li><strong>Данные сохраняются не полностью</strong> - проверьте сопоставление полей в настройках</li>
                        </ul>
                    </div>

                    <div className={s.note}>
                        <strong>Если не получается выбрать вакансию:</strong>
                        <ol>
                            <li>Убедитесь, что в основном приложении в пункте "Настройка вакансий" указан смарт-процесс где хранятся вакансии</li>
                            <li>Убедитесь, что в основном приложении в пункте "Настройка соискателей" указано соотношение поля "Вакансия (CRM)"</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Важно:</strong> Если проблемы не решаются, попробуйте выполнить повторную авторизацию
                        в расширении или переустановить его. Если проблемы остались - обратитесь в поддержку, мы поможем
                    </div>
                </div>
            )
        }
    ];

    return <GuideTemplate title="Работа с расширением" steps={steps} onClose={onClose} />;
}
function AnalysisGuide({ onClose }) {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            title: "AI-анализ кандидатов",
            content: (
                <div className={s.guideStep}>
                    <p>Функция автоматического анализа соответствия кандидата требованиям вакансии.</p>

                    <div className={s.instruction}>
                        <h4>Как получить доступ:</h4>
                        <ol>
                            <li>Перейдите в раздел <strong>"Подписка и возможности"</strong></li>
                            <li>Выберите подходящий тарифный план и период подписки</li>
                            <li>Сформируйте счет и оплатите его</li>
                            <li>После активации функция станет доступна</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Важно:</strong> AI-анализ доступен только на платных тарифах.
                        Бесплатный тариф позволяет выполнить только несколько анализов в месяц.
                    </div>
                </div>
            )
        },
        {
            title: "Настройка параметров анализа",
            content: (
                <div className={s.guideStep}>
                    <p>Для точного анализа необходимо настроить требования вакансии.</p>

                    <div className={s.instruction}>
                        <h4>Как настроить:</h4>
                        <ol>
                            <li>Откройте карточку вакансии в CRM</li>
                            <li>Перейдите на вкладку "[RS] Требования вакансии" (появляется после выбора смарт-процесса вакансий в настройках приложения)</li>
                            <li>Заполните компетенции: необходимые навыки, опыт, образование</li>
                            <li>Укажите ограничения: город, район, желаемая зарплата</li>
                            <li>Сохраните настройки</li>
                        </ol>
                    </div>
                    Теперь при анализе кандидатов система будет учитывать эти требования

                    <div className={s.note}>
                        <strong>Совет:</strong> Чем подробнее вы опишете требования, тем точнее будет анализ.
                        Используйте конкретные формулировки и уровни владения навыками. Например, если вы хотите видеть кандидатов только из Екатеринбурга, напишите в ограничениях "Только из Екатеринбурга, удаленная работа или переезд не рассматриваются"
                    </div>

                    <div className={s.note}>
                        <strong>Важно:</strong> Если вы не настроите требования вакансии, система не сможет сделать анализ соискателя.
                    </div>
                </div>
            )
        },
        {
            title: "Как получить анализ резюме",
            content: (
                <div className={s.guideStep}>
                    <p>Анализ доступен непосредственно в карточке кандидата в вашей CRM.</p>

                    <div className={s.instruction}>
                        <h4>Где искать анализ:</h4>
                        <ol>
                            <li>Откройте карточку кандидата в CRM (в том смарт-процессе, куда сохраняются резюме)</li>
                            <li>Найдите вкладку с названием "[RS] Анализ соискателя"</li>
                            <li>Для пакетной оценки откройте вкладки "[RS] Отбор резюме" и "[RS] Дашборд оценок" в карточке вакансии</li>
                            <li>Если анализ еще не выполнялся, автоматически начнется процесс анализа</li>
                            <li>Дождитесь завершения процесса анализа (обычно занимает 1 минуту)</li>
                            <li>Просмотрите результаты анализа в том же разделе</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Примечание:</strong> Если на этом этапе у вас возникли проблемы, перейдите на последний пункт этого гайда
                    </div>
                </div>
            )
        },
        {
            title: "Интерпретация результатов",
            content: (
                <div className={s.guideStep}>
                    <p>Система предоставляет детализированный отчет по каждому кандидату.</p>

                    <div className={s.instruction}>
                        <h4>Элементы отчета:</h4>
                        <ul>
                            <li><strong>Общая оценка</strong> - итоговый балл AI от 1 до 10</li>
                            <li><strong>Зеленые флаги</strong> - сильные стороны кандидата</li>
                            <li><strong>Красные флаги</strong> - недостатки или несоответствия</li>
                            <li><strong>Вопросы для собеседования</strong> - персональные вопросы для соискателя</li>
                        </ul>
                    </div>

                    <div className={s.note}>
                        <strong>Рекомендация:</strong> Используйте вопросы для собеседования из отчета -
                        они специально подобраны для проверки слабых мест кандидата.
                    </div>

                    <div className={s.note}>
                        <strong>Как использовать результаты:</strong>
                        <ul>
                            <li>Оценка выше 8 - кандидат хорошо подходит для вакансии</li>
                            <li>Оценка 6-8 - кандидат требует дополнительной проверки</li>
                            <li>Оценка ниже 6 - кандидат скорее всего не подходит</li>
                            <li>Используйте красные флаги для быстрого отсева неподходящих кандидатов</li>
                            <li>Зеленые флаги помогут выделить сильных кандидатов среди множества откликов</li>
                        </ul>
                    </div>
                </div>
            )
        },
        {
            title: "Решение проблем",
            content: (
                <div className={s.guideStep}>
                    <p>В случае возникновения проблем с анализом, вот несколько возможных решений.</p>

                    <div className={s.instruction}>
                        <h4>Распространенные проблемы и решения:</h4>
                        <ul>
                            <li><strong>Нет вкладки "[RS] Требования вакансии"</strong> - временно переключите смарт-процесс в п. "Настройка вакансий" на любой другой, сохраните, затем верните нужный и ещё раз сохраните.</li>
                            <li><strong>Нет вкладки "[RS] Анализ соискателя"</strong> - временно переключите смарт-процесс в п. "Настройка соискателей" на любой другой, сохраните, затем верните нужный и ещё раз сохраните — после этого заново настройте сопоставление полей.</li>
                        </ul>
                    </div>

                    <div className={s.note}>
                        <strong>Важное условие работы анализа:</strong>
                        <p>AI-анализ кандидатов работает только при выполнении следующих условий:</p>
                        <ol>
                            <li>В разделе "Настройка соискателей" настроено сопоставление поля <strong>"Вакансия (CRM)"</strong></li>
                            <li>В разделе "Настройка вакансий" выбран смарт-процесс для вакансий</li>
                            <li>Карточка кандидата должна быть связана с вакансией</li>
                            <li>В карточке вакансии должны быть заполнены требования для анализа (навыки, опыт, образование)</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Если проблемы не решаются:</strong>
                        <ol>
                            <li>Проверьте, активна ли ваша подписка в разделе "Подписка и возможности"</li>
                            <li>Убедитесь, что у вас остались доступные анализы в текущем периоде</li>
                            <li>Проверьте выполнение всех условий работы анализа (см. выше)</li>
                            <li>Попробуйте выполнить анализ для другого кандидата для проверки</li>
                            <li>Обратитесь в техническую поддержку, если проблема повторяется</li>
                        </ol>
                    </div>
                </div>
            )
        }
    ];

    return <GuideTemplate title="Анализ соискателя" steps={steps} onClose={onClose} />;
}
function HHAutomationGuide({onClose}) {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            title: "Подключение аккаунта HH.ru",
            content: (
                <div className={s.guideStep}>
                    <p>Для автоматического сбора откликов необходимо авторизоваться на HH.ru.</p>

                    <div className={s.instruction}>
                        <h4>Как авторизоваться:</h4>
                        <ol>
                            <li>Перейдите в раздел <strong>"Автоматизация HH.ru"</strong></li>
                            <li>Нажмите кнопку "АВТОРИЗОВАТЬСЯ НА HH.RU"</li>
                            <li>Разрешите приложению доступ к вашему аккаунту HH.ru</li>
                            <li>Дождитесь завершения процесса авторизации</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Важно:</strong> Используйте аккаунт главного менеджера, который имеет доступ
                        ко всем откликам и вакансиям. Это обеспечит корректную работу автоматизации.
                    </div>
                </div>
            )
        },
        {
            title: "Настройка автоматического сбора откликов",
            content: (
                <div className={s.guideStep}>
                    <p>После авторизации можно настроить автоматическое сохранение откликов в CRM.</p>

                    <div className={s.instruction}>
                        <h4>Как настроить:</h4>
                        <ol>
                            <li>Выберите направление (воронку) для сохранения откликов (если не выбрано - отклики не
                                сохраняются)
                            </li>
                            <li>Укажите ответственного за новые отклики</li>
                            <li>Нажмите "Сохранить" для применения настроек</li>
                            <li>Система начнет автоматически заносить новые отклики</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Особенности:</strong> Каждый отклик сохраняется как отдельный элемент в выбранном
                        направлении
                    </div>
                    <div className={s.note}>
                        <strong>Важно:</strong> Чтобы отклик автоматически привязывался к соответствующей вакансии, необходимо сделать следующее:
                        <ol>
                            <li>В пункте меню "настройка вакансий" выберите смарт процесс, где хранятся ваши вакансии</li>
                            <li>Выберите поле, в котором хранится ID вакансии на HH.ru в указанном смарт-процессе</li>
                            <li>Нажмите "Сохранить" для применения настроек</li>
                        </ol>
                    </div>
                </div>
            )
        },
    ];

    return <GuideTemplate title="Автоматизация HH.ru" steps={steps} onClose={onClose}/>;
}

function ChatGuide({onClose}) {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            title: "Доступ к чату",
            content: (
                <div className={s.guideStep}>
                    <p>Функция позволяет общаться с кандидатами прямо из карточки CRM без перехода на HH.ru.</p>

                    <div className={s.instruction}>
                        <h4>Как получить доступ:</h4>
                        <ol>
                            <li>Откройте карточку кандидата в CRM</li>
                            <li>Перейдите на вкладку "[RS] Чат с соискателем"</li>
                            <li>Авторизуйтесь под вашим аккаунтом hh.ru</li>
                            <li>Выберите вакансию, по которой будете вести общение</li>
                        </ol>
                    </div>
                    <div className={s.note}>
                        <strong>Особенности:</strong> Чат с соискателем работает только в браузерной версии Bitrix24
                    </div>
                </div>
            )
        },
        {
            title: "Как пользоваться чатом",
            content: (
                <div className={s.guideStep}>
                    <p>Чат повторяет функционал мессенджера HH.ru.</p>

                    <div className={s.instruction}>
                        <h4>Основные функции:</h4>
                        <ul>
                            <li><strong>Отправка сообщений</strong> - ввод текста и отправка Enter или кнопкой</li>
                            <li><strong>Статусы сообщений</strong> - индикаторы отправки, доставки и прочтения</li>
                            <li><strong>История переписки</strong> - полная история сообщений с кандидатом</li>
                            <li><strong>Информация о кандидате</strong> - основные данные и ссылка на резюме</li>
                            <li><strong>Смена вакансии</strong> - возможность выбрать другую вакансию для общения</li>
                        </ul>
                    </div>

                    <div className={s.note}>
                        <strong>Особенности:</strong> Все сообщения синхронизируются с HH.ru. Сообщения, отправленные
                        через приложение, отобразятся на сайте, и наоборот.
                    </div>
                </div>
            )
        },
        {
            title: "Решение распространенных проблем",
            content: (
                <div className={s.guideStep}>
                    <p>Если чат не работает корректно, вот несколько способов решения проблем.</p>

                    <div className={s.instruction}>
                        <h4>Возможные проблемы и решения:</h4>
                        <ul>
                            <li><strong>Не открывается чат после авторизации</strong> - проверьте что указали соответствие поля "Ссылка на резюме" в п. меню "Настройка соискателей". Убедитесь что ссылка на резюме занесена в это поле в карточке соискателя</li>
                            <li><strong>Не получается авторизоваться</strong> - убедитесь что работаете из браузера. Чат пока не поддерживает десктопную версию Bitrix24</li>
                            <li><strong>Сообщения не отправляются</strong> - обновите страницу и попробуйте снова</li>
                            <li><strong>Не отображается история</strong> - возможно, с кандидатом нет активного диалога по выбранной вакансии
                            </li>
                            <li><strong>Ошибки подключения</strong> - проверьте интернет-соединение</li>
                        </ul>
                    </div>
                </div>
            )
        }
    ];

    return <GuideTemplate title="Чат с соискателями" steps={steps} onClose={onClose}/>;
}

function RefreshGuide({onClose}) {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            title: "Обновление данных резюме",
            content: (
                <div className={s.guideStep}>
                    <p>Функция позволяет актуализировать данные кандидата в CRM по информации из HH.ru.</p>

                    <div className={s.instruction}>
                        <h4>Как использовать:</h4>
                        <ol>
                            <li>Откройте карточку кандидата в CRM</li>
                            <li>Нажмите на кнопку "[RS] Обновить информацию"</li>
                            <li>Система загрузит актуальные данные из резюме</li>
                            <li>Изменения будут отмечены в комментариях элемента</li>
                        </ol>
                    </div>

                    <div className={s.note}>
                        <strong>Важно:</strong> Для работы функции необходима активная авторизация на HH.ru
                        и корректно настроенное сопоставление полей.
                    </div>
                </div>
            )
        },
        {
            title: "Что обновляется",
            content: (
                <div className={s.guideStep}>
                    <p>Система может обновлять различные данные в зависимости от настроек сопоставления полей.</p>

                    <div className={s.instruction}>
                        <h4>Обновляемые данные:</h4>
                        <ul>
                            <li><strong>Контактная информация</strong> - телефоны, email, адреса</li>
                            <li><strong>Профессиональные данные</strong> - опыт работы, навыки, образование</li>
                            <li><strong>Личная информация</strong> - фото, дата рождения, гражданство</li>
                            <li><strong>Предпочтения</strong> - желаемая должность, зарплата, график работы</li>
                            <li><strong>Дополнительная информация</strong> - языки, сертификаты, рекомендации</li>
                        </ul>
                    </div>

                    <div className={s.note}>
                        <strong>Ограничения:</strong> Обновляются только те поля, которые настроены в сопоставлении.
                        Данные в не настроенных полях остаются без изменений.
                    </div>
                </div>
            )
        },
        {
            title: "Контроль изменений в данных",
            content: (
                <div className={s.guideStep}>
                    <p>Система фиксирует все изменения, сделанные при обновлении данных.</p>

                    <div className={s.instruction}>
                        <h4>Как отслеживать:</h4>
                        <ul>
                            <li><strong>Комментарии в карточке</strong> - автоматическое добавление записей о изменениях
                            </li>
                        </ul>
                    </div>
                </div>
            )
        }
    ];

    return <GuideTemplate title="Обновление данных" steps={steps} onClose={onClose}/>;
}

// Шаблон для всех руководств
function GuideTemplate({title, steps, onClose}) {
    const [currentStep, setCurrentStep] = useState(0);

    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            onClose();
        }
    };

    const handlePrev = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleStepClick = (stepIndex) => {
        setCurrentStep(stepIndex);
    };

    return (
        <div className={s.guideTemplate}>
            <div className={s.guideHeader}>
                <h2>{title}</h2>
                <button className={s.closeButton} onClick={onClose}>×</button>
            </div>

            <div className={s.progressBar}>
                <div
                    className={s.progressFill}
                    style={{width: `${((currentStep + 1) / steps.length) * 100}%`}}
                ></div>
            </div>

            <div className={s.stepIndicator}>
                {steps.map((_, index) => (
                    <div
                        key={index}
                        className={`${s.stepDot} ${currentStep === index ? s.active : ''}`}
                        onClick={() => handleStepClick(index)}
                        title={`Шаг ${index + 1}: ${steps[index].title}`}
                    >
                        {index + 1}
                    </div>
                ))}
            </div>

            <div className={s.stepContent}>
                <h3>{steps[currentStep].title}</h3>
                {steps[currentStep].content}
            </div>

            <div className={s.stepNavigation}>
                <button
                    onClick={handlePrev}
                    disabled={currentStep === 0}
                    className={s.navButton}
                >
                    Назад
                </button>

                <div className={s.stepCounter}>
                    Шаг {currentStep + 1} из {steps.length}
                </div>

                <button
                    onClick={handleNext}
                    className={s.navButton}
                >
                    {currentStep === steps.length - 1 ? 'Завершить' : 'Далее'}
                </button>
            </div>
        </div>
    );
}
